import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useStudentBalance() {
  return useQuery({
    queryKey: ["student", "balance"],
    queryFn: async () => {
      const res = await apiClient.get("/api/v1/me/student/balance/");
      return res.data;
    },
  });
}

export { useStudentBalance };
